import { Theme } from "../../data/style/Theme";
import { MainText } from "../../data/style/Style";
import { useAuth } from "../../context/AuthContext";
import useScreenSize from "../../context/ScreenContext";

const ExerciseWeight = ({ weight_info }) => {
  const { settings } = useAuth();
  const { mobileDevice } = useScreenSize();

  return (
    <MainText
      sx={{ color: Theme.palette.muted + " !important" }}
      fontSize={mobileDevice ? "0.5rem" : "0.7rem"}
    >
      (
      {settings.weight === 0 ? (
        <>
          {weight_info.men_kg} / {weight_info.women_kg}
          &nbsp; kg
        </>
      ) : (
        <>
          {weight_info.men_lb} / {weight_info.women_lb}
          &nbsp; lb
        </>
      )}
      )
    </MainText>
  );
};

export default ExerciseWeight;
